import React from 'react';
import {useTranslation} from 'react-i18next';
import {Button, Grid} from '@mui/material';
import {FormBuilder} from '../../../../../form/FormBuilder';
import {onRejectSubmit} from '../../../../../form/errorHandler';
import schema from './schema/menu_item.json';
import {FormSchema} from '../../../../../form/logic/FormSchema';
import {FormState} from '../../../../../form/state/FormState';
import {useNotifications} from '../../hooks/useNodifications';
import {FormMenuItem} from '../../model/FormMenuItem';
import {useMenuItemsContext} from '../../contexts/MenuItemsContext';

interface Props {
  partial: Partial<FormMenuItem>;
}

export default function MenuItemEditorCreate({partial}: Props) {
  const {t} = useTranslation();
  const {sendSuccess} = useNotifications();
  const {handleCreate, locked} = useMenuItemsContext();

  function onSubmit(formData: any, state: FormState) {
    handleCreate(formData).then(() => sendSuccess(`MenuItem created`));
  }

  return (
    <Grid container spacing={3} rowSpacing={3}>
      <Grid item xs={12}>
        <FormBuilder
          onRejectSubmit={onRejectSubmit}
          formSchema={schema as FormSchema}
          initialValues={partial}
          onSubmit={onSubmit}
        >
          <Button disabled={locked} type={'submit'}>
            {t('shared.save')}
          </Button>
        </FormBuilder>
      </Grid>
    </Grid>
  );
}
